import { render } from "./pointList.vue?vue&type=template&id=40fa1a9f&scoped=true"
import script from "./pointList.vue?vue&type=script&lang=js"
export * from "./pointList.vue?vue&type=script&lang=js"

import "./pointList.vue?vue&type=style&index=0&id=40fa1a9f&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40fa1a9f"]])

export default __exports__